// extracted by mini-css-extract-plugin
export default {"sidenav":"ToggleMenu_sidenav__EWhuy","inner":"ToggleMenu_inner__e3Yu0","group":"ToggleMenu_group__-tkGs","title":"ToggleMenu_title__wal64"};